module.exports = __webpack_public_path__ + "img/旅居基地.54b3288a.png";